import styled from 'styled-components';
import { lighten } from 'polished';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import colors, { MISCHKA, GRAY_SUIT } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  opacity: ${p => p.opacity || '1'};

  .stepper {
    &__dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid ${MISCHKA};

      &--active {
        border-color: ${p => p.theme.palette.primary.main || colors.primary};
        background-color: ${p => p.theme.palette.primary.main || colors.primary};
      }

      &--complete {
        border-color: ${p => p.theme.palette.primary.main || colors.primary};
      }

      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }

  &.stepper {
    &--iframe-progress {
      justify-content: center;
      margin-top: 45px;
      margin-bottom: 25px;

      .stepper {
        &__dot {
          width: 16px;
          height: 4px;
          border-radius: 6px;
          border: none;
          background-color: ${GRAY_SUIT};
          transition: 0.3s ease-in-out;

          &--active {
            width: 38px;
            background-color: ${p => p.theme.palette.primary.main || colors.primary};
          }

          &--complete {
            background-color: ${p => lighten(0.3, p.theme.palette.primary.main || colors.primary)};
          }

          &:not(:last-of-type) {
            margin-right: 4px;
          }
        }
      }
    }
  }
`;

export const Title = styled(Typography)`
  margin-right: 14px;

  ${breakpoints.down('md')} {
    margin-right: 5px;
  }

  &.not-active {
    color: ${p => (p.theme.partnerStyles ? p.theme.palette.primary.main : MISCHKA)};
  }
`;

export default StepperContainer;
